(function(){
  function init(root){
    if(!root||root.dataset.ogcInvoicesReady==='true') return;
    root.dataset.ogcInvoicesReady='true';
    var els=root.querySelectorAll('[data-reveal]');
    if(!('IntersectionObserver' in window)){els.forEach(function(el){el.classList.add('is-visible');});}
    else {var io=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target);}});},{threshold:.1,rootMargin:'0px 0px -40px 0px'});els.forEach(function(el){io.observe(el);});}
    if(window.lucide) window.lucide.createIcons({attrs:{'aria-hidden':'true'}});
  }
  function boot(){document.querySelectorAll('[data-ogc-invoices-page]').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
